import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { signInUser } from "../Components/Utility/Auth";
import { Customer } from "../models/customer.model";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";
const user = signInUser();
// @ts-ignore
const { aamarId = "", warehouse = "" } = user || {};

export const CustomerApi = createApi({
  reducerPath: "customerApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["Customer"],
  endpoints: (builder) => ({
    Customers: builder.query<Customer[], any>({
      query: (args) => {
        const u = signInUser();
        const w = args?.warehouse || warehouse || u?.warehouse || "allWh";
        const a = args?.aamarId || aamarId || u?.aamarId || "";
        return `/customer/${w && w !== "undefined" ? w : "allWh"}/${a}`;
      },
      providesTags: ["Customer"],
    }),

    CustomerDW: builder.query<Customer[], any>({
      query: ({ q }) => `/customer/search/${aamarId}/${q}`,
      providesTags: ["Customer"],
    }),
    CustomersExport: builder.query<Customer[], any>({
      query: ({ warehouse: w, aamarId: a }) => {
        const u = signInUser();
        const wh = w || u?.warehouse || "allWh";
        const aid = a || u?.aamarId || "";
        return `/customer/export/${wh && wh !== "undefined" ? wh : "allWh"}/${aid}`;
      },
      providesTags: ["Customer"],
    }),
    Customer: builder.query<Customer[], any>({
      query: ({ id, aamarId }) => `/customer/select/${aamarId}/${id}`,
      providesTags: ["Customer"],
    }),
    AddImportCustomer: builder.mutation<{}, Customer>({
      query: (Customer) => ({
        url: "/customer/import",
        method: "POST",
        body: Customer,
      }),
      invalidatesTags: ["Customer"],
    }),
    GetCustomerById: builder.query<Customer[], any>({
      query: ({ id, aamarId }) => `/customer/getCustomerById/${aamarId}/${id}`,
      providesTags: ["Customer"],
    }),
    customerCount: builder.query<Customer[], any>({
      query: ({ aamarId }) => `/customer/count/${aamarId}`,

      providesTags: ["Customer"],
    }),
    // CustomerDW: builder.query<Customer[], void>({
    //   query: () => `/customer/dw/`,
    //   providesTags: ["Customer"],
    // }),

    customerContact: builder.query<Customer, any>({
      query: ({ page, size, q }) => `/customer/contact/${page}/${size}?q=${q}`,
      // query: ({page, size, q}) => `/Customer`,
      providesTags: ["Customer"],
    }),
    
    customerPagenation: builder.query<Customer[], any>({
      query: ({ page, size, warehouse, aamarId, q }) =>
        `/customer/all/${page}/${size}/${warehouse}/${aamarId}?q=${q}`,
      // query: ({page, size, q}) => `/Customer`,
      providesTags: ["Customer"],
    }),

    addCustomer: builder.mutation<{}, Customer>({
      query: (Customer) => ({
        url: "/customer",
        method: "POST",
        body: Customer,
      }),
      invalidatesTags: ["Customer"],
    }),
    updateCustomer: builder.mutation<void, Customer>({
      query: ({ _id, ...rest }) => ({
        url: `/customer/${_id}`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["Customer"],
    }),
    updatePointCustomer: builder.mutation<void, Customer>({
      query: ({ _id, ...rest }) => ({
        url: `/customer/point/${_id}`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["Customer"],
    }),
    deleteCustomer: builder.mutation<void, string>({
      query: (id) => ({
        url: `/customer/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Customer"],
    }),
  }),
});

export const {
  useCustomersQuery,
  useCustomersExportQuery,
  useCustomerQuery,
  useGetCustomerByIdQuery,
  // useCustomerPointQuery,
  useCustomerDWQuery,
  useAddCustomerMutation,
  useCustomerCountQuery,
  useCustomerPagenationQuery,
  useCustomerContactQuery,
  useUpdateCustomerMutation,
  useUpdatePointCustomerMutation,
  useAddImportCustomerMutation,
  useDeleteCustomerMutation,
} = CustomerApi;

export default CustomerApi;
